import { render, staticRenderFns } from "./SurveySubmitted.vue?vue&type=template&id=e23f6714&scoped=true"
import script from "./SurveySubmitted.vue?vue&type=script&lang=js"
export * from "./SurveySubmitted.vue?vue&type=script&lang=js"
import style0 from "./SurveySubmitted.vue?vue&type=style&index=0&id=e23f6714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23f6714",
  null
  
)

export default component.exports